import { Col, Row } from 'reactstrap';

const ColorList = [
  {
    name: "green",
    hex: "#008000"
  },
  {
    name: "blue",
    hex: "#0000ff"
  },
  {
    name: "pink",
    hex: "#ffc0cb"
  },
  {
    name: "red",
    hex: "#ff0000"
  }, 
  {
    name: "purple",
    hex: "#800080"
  },
  {
    name: "gold",
    hex: "#ffd700"
  },
  {
    name: "brown",
    hex: "#a52a2a"
  }, 
  // {
  //   name: "black",
  //   hex: "#000000"
  // },  
  // {
  //   name: "white",
  //   hex: "#ffffff"
  // }, 
  // {
  //   name: "yellow",
  //   hex: "#ffff00"
  // }, 
  // {
  //   name: "gray",
  //   hex: "#808080"
  // },  
]

const MyColor = (props) => {
  return (
    <div 
      style={{ width: "24px", height: "24px", borderRadius: "50%", marginBottom: "5px", backgroundColor: props.color, border: props.isActive ? `2px solid black` : "1px solid #e4e4e4" }} 
      onClick={() => props.onClick(props.value)}
      >
    </div>
  )
}

const ColorPicker = (props) => {
  return (
    <Col>
      <Row>
      {
        ColorList.map((color, index) => {
          return (
            <div  style={{ marginRight: "10px", cursor: "pointer" }} key={index}>
              <MyColor 
                color={color.hex} 
                value={color.name}
                isActive={props.isActive === color.name}
                onClick={(value) => props.onClick(value)}
              />
            </div>
          )
        })
      }
      </Row>
    </Col>
  )
}

export default ColorPicker;